import { Formik, useField } from "formik";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";

import {
  Form,
  Field,
  Input,
  Label,
  SubmitButton,
} from "../../../../../components/forms";
import { Logo } from "../../Logo";
import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import useCompetitorNumberScreen from "./useCompetitorNumberScreen";

const CompetitorNumberField = ({
  entryData,
  setCompetitorNumber,
  isFetchingEntryData,
}: Pick<
  ReturnType<typeof useCompetitorNumberScreen>,
  "entryData" | "setCompetitorNumber" | "isFetchingEntryData"
>) => {
  const [field, meta, { setValue }] = useField("competitorNumber");

  useEffect(() => {
    field.value && !meta.error
      ? setCompetitorNumber(field.value)
      : setCompetitorNumber("");
  }, [field.value, meta.error, meta.touched, setCompetitorNumber]);

  return (
    <Field name="competitorNumber">
      <Label>Competitor Number</Label>
      <Input
        type="text"
        onChange={(e) =>
          setValue(e.currentTarget.value.toUpperCase().replace(" ", ""))
        }
      />
      {entryData !== undefined || isFetchingEntryData ? (
        <div className="mt-1">
          {!isFetchingEntryData ? (
            <div
              className={`${entryData ? "text-success" : "text-danger"} small`}
            >
              {entryData
                ? `✅ Found matching competitor: ${entryData.user.firstName} ${entryData.user.lastName}`
                : "❌ Invalid competitor number"}
            </div>
          ) : (
            <Spinner animation="border" size="sm" />
          )}
        </div>
      ) : null}
    </Field>
  );
};

export default function CompetitorNumberScreen() {
  const {
    competition,
    initialValues,
    onSubmit,
    schema,
    setCompetitorNumber,
    isFetchingEntryData,
    entryData,
  } = useCompetitorNumberScreen();
  return (
    <Panel>
      <Logo />
      <Heading>
        {competition ? `Welcome to ${competition.name}` : <br />}
      </Heading>
      <Intro>
        Please enter a competitor number to view the live leaderboard.
      </Intro>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={schema}
        validateOnChange
      >
        <Form>
          <CompetitorNumberField
            setCompetitorNumber={setCompetitorNumber}
            entryData={entryData}
            isFetchingEntryData={isFetchingEntryData}
          />
          <SubmitButton>View live scores</SubmitButton>
        </Form>
      </Formik>
    </Panel>
  );
}
